var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],attrs:{"src":_vm.src,"alt":_vm.alt,"width":_vm.options.resize.width,"height":_vm.options.resize.height}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }